
export default {
  props: {
    categoryId: {
      type: Number,
      required: true
    },
    categoryName: {
      type: String,
      required: true
    },
    categoryUrl: {
      type: String,
      required: true
    }
  },
  data: () => ({
    latestDiagrams: [],
    category: undefined
  }),
  async fetch () {
    this.latestDiagrams = await this.$backend.diagrams.get({
      categories: this.categoryId,
      ordering: '-refresh_date',
      page_size: 3
    }).then(d => d.results)
  },
  fetchOnServer: true,
  computed: {
    listName () {
      return 'Diagrams in sub-category ' + this.categoryName
    }
  }
}
